import 'babel-polyfill';
import Vue from 'vue';
import VueGtag from 'vue-gtag';
import pymChild from './embed/index';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

Vue.use(VueGtag, {
  config: {
    id: 'UA-70053831-5',
    params: {
      send_page_view: true,
    },
  },
}, router);

// Init VueJS app.
new Vue({
  router,
  store,
  mounted: () => {
    pymChild.sendHeight();
  },
  updated: () => {
    pymChild.sendHeight();
  },
  render: (h) => h(App),
}).$mount('#app');
